export default {"src":"/_next/static/media/stressMotivationMobile.184c40a8.svg","height":244,"width":272,"blurWidth":0,"blurHeight":0};